import gql from "graphql-tag";

export const HELLO_QUERY = gql`
  query HELLO_QUERY {
    hello
  }
`;

export const CHECK_IF_COMPANY_EXISTS = gql`
  query CHECK_IF_COMPANY_EXISTS($companyName: String!, $checkType: String!) {
    checkIfCompanyExists(companyName: $companyName, checkType: $checkType) {
      status
      description
    }
  }
`;

export const GET_USERNAME = gql`
  query Query($accessToken: String!) {
    getUsername(accessToken: $accessToken) {
      username
    }
  }
`;

export const AXIOS_GQL_QUERIES = {
  GET_USERNAME: `query getUsername($accessToken: String!) { getUsername(accessToken: $accessToken) { username } }`,
  CHECK_IF_COMPANY_EXISTS: `query CHECK_IF_COMPANY_EXISTS($companyName: String!, $checkType: String!) { checkIfCompanyExists(companyName: $companyName, checkType: $checkType) { status description } }`
}
